import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "./Gallery.css";
import { FreeBreakfast } from "@mui/icons-material";

const Gallery = ({ images }) => {
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(mainImageIndex);
    }
  }, [mainImageIndex]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => setMainImageIndex(next),
  };

  const handleThumbnailClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  const getYouTubeThumbnail = (url) => {
    const match = url.match(/\/embed\/([a-zA-Z0-9_-]+)/);
    return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
  };

  return (
    <div className="slider-product">
      <div className="gallery-container">
        <div className="gallery-content">
          <div className="main-image-container">
            {images.length > 1 ? (
              <Slider {...settings} ref={sliderRef}>
                {images.map((media, index) => (
                  <div key={index} className="test-div">
                    <div className="image-container">
                      {media.type === "image" ? (
                        <img src={media.src} alt={media.alt} className="main-image" />
                      ) : (
                        <iframe
                          className="main-video"
                          src={media.src}
                          title="Video"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      )}
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="image-container">
                <img
                  src={images[0]?.src}
                  alt={images[0]?.alt}
                  className="main-image"
                />
              </div>
            )}
          </div>

          {images.length > 1 && (
            <div className="thumbnails-container">
              {!isMobile ? (
                // original thumbnails (unchanged)
                images.map((media, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${index === mainImageIndex ? "active" : "inactive"}`}
                    onClick={() => handleThumbnailClick(index)}
                  >
                    {media.type === "image" ? (
                      <img src={media.src} alt={`Thumbnail ${index}`} loading="lazy" />
                    ) : (
                      <img
                        src={getYouTubeThumbnail(media.src)}
                        alt={`Thumbnail ${index}`}
                        className="video-thumbnail"
                      />
                    )}
                  </div>
                ))
              ) : (
                // splide slider on mobile
                <Splide
                  options={{
                    type   : 'slide',
                    gap: "40px",
                    
                    perPage: 'auto',
                    arrows: false,
                    pagination: false,
                    autoWidth: true,
                    breakpoints: {
                      768: {

                      }
                    }
                  }}
                >
                  {images.map((media, index) => (
                    <SplideSlide key={index}>
                      <div
                        className={`thumbnail ${index === mainImageIndex ? "active" : "inactive"}`}
                        onClick={() => handleThumbnailClick(index)}
                      >
                        {media.type === "image" ? (
                          <img src={media.src} alt={`Thumbnail ${index}`} loading="lazy" />
                        ) : (
                          <img
                            src={getYouTubeThumbnail(media.src)}
                            alt={`Thumbnail ${index}`}
                            className="video-thumbnail"
                          />
                        )}
                      </div>
                    </SplideSlide>
                  ))}
                </Splide>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
